module.exports = __webpack_public_path__ + "static/media/S3N7-1.9be4d130.svg";